import { FormattedText } from "@tm/static";
import { theme } from "@tm/utility/global";
import React from "react";
import LandingButton from "../../../../../components/LandingButton/LandingButton";
import { FooterCell, FooterPriceBlock, FooterRow } from "./ComparePlans.styles";
import { IComparePlansData, IComparePlansFooterCta } from "./types";

const PRICE_STYLE: React.CSSProperties = {
  fontSize: "16px",
  fontWeight: 900,
  color: theme.blackText,
};

interface CompareTableFooterProps {
  footer: IComparePlansData["footer"];
  planIds: string[];
  recommendedId: string | null;
  onBuyPress: (params: IComparePlansFooterCta["params"]) => void;
}

const CompareTableFooter = ({
  footer,
  planIds,
  recommendedId,
  onBuyPress,
}: CompareTableFooterProps) => {
  const { data } = footer;

  return (
    <FooterRow>
      <FooterCell $isFirst />
      {planIds.map((id) => {
        const item = data?.[id];
        if (!item?.cta?.params) return <FooterCell key={id} />;

        return (
          <FooterCell key={id} $isRecommended={id === recommendedId}>
            <FooterPriceBlock>
              {item.label && (
                <span>
                  <FormattedText value={item.label} baseStyle={PRICE_STYLE} />
                  {(item.label as any)?.unit && (
                    <FormattedText value={{ text: (item.label as any).unit }} />
                  )}
                </span>
              )}
              <LandingButton
                customTitle={item.cta?.text || "BUY NOW"}
                customWidth="100%"
                customHeight="32px"
                fontSize="12px"
                onClick={() => onBuyPress(item.cta.params)}
              />
            </FooterPriceBlock>
          </FooterCell>
        );
      })}
    </FooterRow>
  );
};

export default CompareTableFooter;
